<div class="row">

    <div class="col-12 col-md-4">
        <div class="form-inline appointment-filter">
            <div class="form-group">
                <strong class="filter-category" translate>GENERAL_REUSABLE.FILTER.FILTER_BY </strong>
                <br>
                <div class="filter-group">
                    <label for="numberOfAppointments" translate>GENERAL_REUSABLE.FILTER.NUM_APPTS</label>
                    <select name="numberOfAppointments" id="numberOfAppointments" [(ngModel)]="apptNumber" class="form-select d-inline-block">
                        <option value="" selected translate>GENERAL_REUSABLE.FILTER.ANY</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-md-5">
        <div class="form-inline appointment-filter">
            <div class="form-group">
                <strong class="filter-category" translate>GENERAL_REUSABLE.FILTER.JUMP_TO </strong>
                <br>
                <div class="filter-group">
                    <label for="radSoonest">
                        <input type="radio" id="radSoonest" name="radAvail" [(ngModel)]="soonestAvail" value="Y">
                        <span translate>GENERAL_REUSABLE.FILTER.SOONEST</span>
                    </label>
                    <br>
                    <label for="radThisMonth">
                        <input type="radio" id="radThisMonth" name="radAvail" [(ngModel)]="soonestAvail" value="N">
                        <span translate>GENERAL_REUSABLE.FILTER.STAY</span>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="col-2">
        <button class="btn btn-lg btn-primary" title="{{'GENERAL_REUSABLE.FILTER.APPLY' | translate}}" (click)="applyFilter()" (keyup.enter)="applyFilter()" (keyup.space)="applyFilter()">
            <span translate>GENERAL_REUSABLE.FILTER.APPLY</span>
        </button>
    </div>

</div>

